import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

interface UseUserTermsOfServicePostProps {
  slug: string;
  userId: string;
  version: number;
}

const useUserTermsOfServicePost = () => {
  const resource = useCallback(
    (payload: UseUserTermsOfServicePostProps): Request => {
      const { slug, userId, version }: UseUserTermsOfServicePostProps = payload;

      const requestUrl = `${API_BASE_URL}/api/v3/user/${userId}/terms-of-service/${slug}/version/${version}/`;

      return new Request(requestUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });
    },
    [],
  );

  return useRestMutation(resource as (arg0: unknown) => Request);
};

export default useUserTermsOfServicePost;
